/*******************************************************************************
 * Copyright (c) 2018. keni <$email>
 *
 * This file images.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * images.js can not be copied and/or distributed
 * without the express permission of keni
 ******************************************************************************/
import {_} from 'underscore';
import {HUB, CDN_URL, BUCKET_NAME, IMAGE_URL_BASE} from '../../../../../../resources/assets/js/config/config';

export function readImageFromData(obj) {
	let url = _.first(obj.images) || null;

	if (url === null) {
		return null;
	}
	return url;
}

export function createMainImage(item) {
	// console.log(CDN_URL, BUCKET_NAME, IMAGE_URL_BASE.entities_url);
	let url = readImageFromData(item);
	if (url === null) {
		// console.error('images is null', entity);
		return null;
	}
	// console.log('url', url, this.images_url);
	url = CDN_URL + '/' + BUCKET_NAME + '/' + url.url;

	return url;
}

export function imageExists(url, success, failure) {
	let img = new Image(),    // the
		loaded = false,
		has_error = false,
		errors = [];

	// Run only once, when `loaded` is false. If `success` is a
	// function, it is called with `img` as the context.
	img.onload = function () {
		if (loaded) {
			return;
		}

		loaded = true;

		if (success && success.call) {
			success.call(img);
		}
	};

	// Run only once, when `errored` is false. If `failure` is a
	// function, it is called with `img` as the context.
	img.onerror = function () {
		if (has_error) {
			return;
		}

		errors[url] = has_error = true;

		if (failure && failure.call) {
			failure.call(img);
		}
	};

	// If `url` is in the `errors` object, trigger the `onerror`
	// callback.
	if (errors[url]) {
		img.onerror.call(img);
		return;
	}

	// Set the img src to trigger loading
	img.src = url;

	// If the image is already complete (i.e. cached), trigger the
	// `onload` callback.
	if (img.complete) {
		img.onload.call(img);
	}
}

/**
 * @property obj.logo.file_name
 * @property obj.logo
 * @param obj
 * @param {string} base_url
 * @returns {string}
 */
export function readTeamImage(obj, base_url) {
	// console.log('obj.logo',obj.logo.file_name);
	let file = obj.logo.file_name,
		extension = obj.logo.ext,
		compiled = file + '.' + extension,
		imageSrc = `${base_url}${compiled}`;

	return imageSrc;
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/images.js